import React, { useState, useRef, useEffect } from "react";
import { Dropdown, Row, Nav, Tab } from "react-bootstrap";
import { Link } from "react-router-dom";
import PageTitle from "../../../layouts/PageTitle";
import {
  approveTenant,
  getRegisterTenant,
  getTenant,
} from "../../../../services/TenantsService";
import { IMAGES } from "../../../constant/theme";
import RazorpayModal from "../../../components/superAdmin/RazorpayModal";
import AddTenantPackage from "../../../components/superAdmin/AddTenantPackage";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

const theadData = [
  { heading: "Name", sortingVale: "name" },
  { heading: "Email", sortingVale: "email" },
  { heading: "Mobile", sortingVale: "phone" },
  { heading: "Contact Name", sortingVale: "name" },
  { heading: "Owner Name", sortingVale: "ownerName" },
  { heading: "Owner Mobile", sortingVale: "ownerMobile" },
  { heading: "Subscription", sortingVale: "subscription" },
  { heading: "Amount", sortingVale: "amount" },
  { heading: "Grace Days", sortingVale: "graceDays" },
  // { heading: "Start Date", sortingVale: "startDate" },
  // { heading: "Expire Date", sortingVale: "expireDate" },
  { heading: "IsVerified", sortingVale: "isVerified" },
  { heading: "Status", sortingVale: "status" },
  { heading: "Action", sortingVale: "action" },
];

const svg1 = (
  <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect x="0" y="0" width="24" height="24"></rect>
      <circle fill="#000000" cx="5" cy="12" r="2"></circle>
      <circle fill="#000000" cx="12" cy="12" r="2"></circle>
      <circle fill="#000000" cx="19" cy="12" r="2"></circle>
    </g>
  </svg>
);

const PendingTenant = () => {
  const [tenantData, setTenantData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sort, setSortata] = useState(10);
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(10);
  const [search, setSearch] = useState("");
  const [totalElements, setTotalElements] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [currentStart, setCurrentStart] = useState(0);
  const [showRazorpayModal, setShowRazorpayModal] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [iconData, setIconDate] = useState({ complete: false, ind: Number });

  function SotingData(name) {
    const sortedPeople = [...tenantData];
    switch (name) {
      case "name":
        sortedPeople.sort((a, b) => {
          return iconData.complete
            ? a.name.localeCompare(b.name)
            : b.name.localeCompare(a.name);
        });
        break;
      case "email":
        sortedPeople.sort((a, b) => {
          return iconData.complete
            ? a.email.localeCompare(b.email)
            : b.email.localeCompare(a.email);
        });
        break;
      case "phone":
        sortedPeople.sort((a, b) => {
          return iconData.complete
            ? a.phone.localeCompare(b.phone)
            : b.phone.localeCompare(a.phone);
        });
        break;
      case "contactName":
        sortedPeople.sort((a, b) => {
          return iconData.complete
            ? a.contactName.localeCompare(b.contactName)
            : b.contactName.localeCompare(a.contactName);
        });
        break;
      case "status":
        sortedPeople.sort((a, b) => {
          return iconData.complete
            ? a.status.localeCompare(b.status)
            : b.status.localeCompare(a.status);
        });
        break;
      default:
        break;
    }
    setTenantData(sortedPeople);
  }

  function handleSearchChange(e) {
    const value = e.target.value;
    setSearch(value);
    setPage(0); // reset to first page on search
  }

  async function fetchData({ page, size, search }) {
    setLoading(true);
    try {
      const res = await getRegisterTenant(page, size, search);
      setTenantData(res.content);
      setTotalElements(res?.totalElements || 0);
      setTotalPages(res?.totalPages || 0);
      setCurrentStart(res?.number || 0);
    } catch (error) {
      console.error("Error fetching previousReading data:", error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchData({ page, size, search });
  }, [page, size, search]);

  const handleApproveTenant = async (tenant) => {
    if (!tenant.tenantSubcription?.id) {
      Swal.fire({
        icon: "warning",
        title: "Cannot Approve",
        text: "This academy does not have any subscription.",
      });
      return;
    }

    Swal.fire({
      title: "Are you sure you want to verify and approve this academy?",
      text: "You will not be able to recover this action !!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#aaa",
      confirmButtonText: "Yes, approve it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const payload = {
          id: tenant.id,
          approved: true,
        };

        const res = await approveTenant(payload);

        if (res) {
          fetchData({ page, size, search });
          Swal.fire(
            "Approved!",
            "Academy verified and approved successfully",
            "success",
          );
        }
      }
    });
  };

  // const handleApproveTenant = async (tenant) => {
  //   const isConfirmed = window.confirm(
  //     `Are you sure you want to verify and approve"${tenant.name}"?`,
  //   );

  //   if (!isConfirmed) return;

  //   try {
  //     const payload = {
  //       id: tenant.id,
  //       approved: true,
  //     };

  //     const res = await approveTenant(payload);

  //     if (res) {
  //       toast.success("Tenant verified and approved successfully", {
  //         position: "top-right",
  //         autoClose: 1000,
  //       });
  //       fetchData({ page, size, search });
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     toast.error("Failed to approve tenant", {
  //       position: "top-right",
  //       autoClose: 1000,
  //     });
  //   }
  // };

  return (
    <>
      <PageTitle activeMenu={"Registered Academies"} motherMenu={"Academies"} />
      <Row>
        <Tab.Container defaultActiveKey={"List"}>
          <div className="col-lg-12">
            <Nav as="ul" className="nav nav-pills mb-3">
              <Nav.Item as="li">
                <Nav.Link eventKey="List" className="me-1">
                  List View
                </Nav.Link>
              </Nav.Item>
              <Nav.Item as="li">
                <Nav.Link eventKey="Grid">Grid View</Nav.Link>
              </Nav.Item>
            </Nav>
          </div>
          <div className="col-lg-12">
            <Tab.Content className="row tab-content">
              <Tab.Pane eventKey="List" className="col-lg-12">
                <div className="card">
                  <div className="card-header">
                    <h4 className="card-title">Registered Academies</h4>
                  </div>
                  <div className="card-body">
                    <div className="dataTables_wrapper no-footer">
                      <div className="justify-content-between d-sm-flex mb-3">
                        {/* PAGE SIZE DROPDOWN */}
                        <div className="dataTables_length">
                          <label className="d-flex align-items-center">
                            Show
                            <Dropdown className="search-drop ms-2 me-2">
                              <Dropdown.Toggle
                                as="div"
                                className="search-drop-btn"
                              >
                                {size}
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                {[10, 20, 30].map((val) => (
                                  <Dropdown.Item
                                    key={val}
                                    onClick={() => {
                                      setSize(val);
                                      setPage(0);
                                    }}
                                  >
                                    {val}
                                  </Dropdown.Item>
                                ))}
                              </Dropdown.Menu>
                            </Dropdown>
                            entries
                          </label>
                        </div>

                        {/* SEARCH */}
                        <div className="dataTables_filter">
                          <label>
                            Search :{" "}
                            <input
                              type="search"
                              className=""
                              placeholder="Search tenants..."
                              value={search}
                              onChange={handleSearchChange}
                            />
                          </label>
                        </div>
                      </div>

                      {/* TABLE WITH HORIZONTAL SCROLL */}
                      <div className="table-responsive">
                        <table
                          id="example4"
                          className="display dataTable no-footer w-100"
                        >
                          <thead>
                            <tr>
                              {theadData.map((item, ind) => (
                                <th
                                  key={ind}
                                  onClick={() => {
                                    SotingData(item.sortingVale);
                                    setIconDate((prevState) => ({
                                      complete: !prevState.complete,
                                      ind: ind,
                                    }));
                                  }}
                                >
                                  {item.heading}
                                  <span>
                                    {ind !== iconData.ind && (
                                      <i
                                        className="fa fa-sort ms-2 fs-12"
                                        style={{ opacity: "0.3" }}
                                      />
                                    )}
                                    {ind === iconData.ind &&
                                      (iconData.complete ? (
                                        <i
                                          className="fa fa-arrow-down ms-2 fs-12"
                                          style={{ opacity: "0.7" }}
                                        />
                                      ) : (
                                        <i
                                          className="fa fa-arrow-up ms-2 fs-12"
                                          style={{ opacity: "0.7" }}
                                        />
                                      ))}
                                  </span>
                                </th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {tenantData.map((data, ind) => (
                              <tr key={ind}>
                                <td>{data.name}</td>
                                <td>{data.email}</td>
                                <td>{data.phone}</td>
                                <td>{data.contactName}</td>
                                <td>{data?.owner?.name}</td>
                                <td>{data?.owner?.phone}</td>
                                <td>
                                  {
                                    data?.tenantSubcription
                                      ?.tenantSubscriptionEnum
                                  }
                                </td>
                                <td>{data?.tenantSubcription?.amount}</td>
                                <td>{data?.tenantSubcription?.graceDays}</td>

                                {/* <td>{data?.tenantSubcription?.startDate}</td>
                                <td>{data?.tenantSubcription?.expireDate}</td> */}
                                <td>
                                  <span
                                    className={`badge ${
                                      data.isApproved === true
                                        ? "badge-success"
                                        : "badge-warning"
                                    }`}
                                  >
                                    {data.isApproved === true
                                      ? "Approved"
                                      : "Pending"}
                                  </span>
                                </td>
                                <td>{data.status}</td>
                                <td>
                                  <div className="d-flex align-items-center gap-2">
                                    <Link
                                      to="/super-admin/add-academy"
                                      state={{ tenant: data, mode: "edit" }}
                                      className="btn btn-s sharp btn-primary"
                                    >
                                      <i className="fa fa-pencil" />
                                    </Link>

                                    <Dropdown>
                                      <Dropdown.Toggle
                                        variant="success"
                                        className="light sharp i-false"
                                      >
                                        {svg1}
                                      </Dropdown.Toggle>
                                      <Dropdown.Menu
                                        renderOnMount
                                        popperConfig={{
                                          strategy: "fixed",
                                          modifiers: [
                                            {
                                              name: "flip",
                                              options: {
                                                fallbackPlacements: [
                                                  "bottom-end",
                                                  "top-end",
                                                ],
                                              },
                                            },
                                            {
                                              name: "preventOverflow",
                                              options: {
                                                boundary: "viewport",
                                              },
                                            },
                                          ],
                                        }}
                                      >
                                        <Dropdown.Item
                                          onClick={() => {
                                            setShowRazorpayModal(true);
                                            setSelectedData(data);
                                          }}
                                        >
                                          Add Package
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                          onClick={() =>
                                            handleApproveTenant(data)
                                          }
                                        >
                                          Verify & Approve
                                        </Dropdown.Item>
                                      </Dropdown.Menu>
                                    </Dropdown>
                                  </div>
                                  {/* <Link
                                    to={"#"}
                                    className="btn btn-xs sharp btn-danger"
                                  >
                                    <i className="fa fa-trash" />
                                  </Link> */}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>

                      {/* PAGINATION FOOTER */}
                      <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
                        <div className="dataTables_info">
                          <span>
                            Page{" "}
                            <strong>
                              {currentStart + 1} of {totalPages}
                            </strong>
                          </span>
                        </div>
                        <div className="dataTables_paginate paging_simple_numbers">
                          <Link
                            className={`paginate_button previous ${
                              page === 0 ? "disabled" : ""
                            }`}
                            to="#"
                            onClick={(e) => {
                              e.preventDefault();
                              if (page > 0) setPage(page - 1);
                            }}
                          >
                            Previous
                          </Link>

                          <Link
                            className={`paginate_button next ${
                              page + 1 >= totalPages ? "disabled" : ""
                            }`}
                            to="#"
                            onClick={(e) => {
                              e.preventDefault();
                              if (page + 1 < totalPages) setPage(page + 1);
                            }}
                          >
                            Next
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Tab.Pane>
              <Tab.Pane eventKey="Grid" className="col-lg-12">
                <div className="row">
                  {tenantData?.map((item, ind) => (
                    <div
                      className="col-lg-4 col-md-6 col-sm-6 col-12"
                      key={ind}
                    >
                      <div className="card card-profile">
                        <div className="card-header justify-content-end pb-0 border-0">
                          <Dropdown>
                            <Dropdown.Toggle
                              as="button"
                              className="btn btn-link i-false"
                              type="button"
                            >
                              <span className="dropdown-dots fs--1"></span>
                            </Dropdown.Toggle>
                            <Dropdown.Menu
                              align="end"
                              className="dropdown-menu dropdown-menu-right border py-0"
                            >
                              <div className="py-2">
                                <Link
                                  to="/super-admin/add-tenant"
                                  state={{ tenant: item, mode: "edit" }}
                                  className="dropdown-item"
                                >
                                  Edit
                                </Link>
                                <Link
                                  onClick={() => handleApproveTenant(item)}
                                  className="dropdown-item"
                                >
                                  Add Package
                                </Link>
                                <Link
                                  onClick={() => handleApproveTenant(item)}
                                  className="dropdown-item"
                                >
                                  Verify & Approve
                                </Link>
                              </div>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                        <div className="card-body pt-2">
                          <div className="text-center">
                            <div className="profile-photo">
                              <img
                                src={IMAGES?.smallpic2}
                                width="100"
                                className="img-fluid rounded-circle"
                                alt=""
                              />
                            </div>
                            <h3 className="mt-4 mb-1">{item.name}</h3>
                            {/* <p className="text-muted">{item.subject}</p> */}
                            <ul className="list-group mb-3 list-group-flush">
                              <li className="list-group-item px-0 d-flex justify-content-between">
                                <span className="mb-0">Email:</span>
                                <span className="mb-0">{item?.email}</span>
                              </li>
                              <li className="list-group-item px-0 d-flex justify-content-between">
                                <span className="mb-0">Phone:</span>
                                <span>{item?.phone}</span>
                              </li>
                              <li className="list-group-item px-0 d-flex justify-content-between">
                                <span className="mb-0">Contact Name:</span>
                                <span>{item?.contactName}</span>
                              </li>
                              <li className="list-group-item px-0 d-flex justify-content-between">
                                <span className="mb-0">Status:</span>
                                <span>{item?.status}</span>
                              </li>
                            </ul>
                            {/* <Link
                              to="/super-admin/about-tenant"
                              state={{ user: item }}
                              className="btn btn-outline-primary btn-rounded mt-3 px-4"
                            >
                              Read More
                            </Link> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </Tab.Pane>
            </Tab.Content>
          </div>
        </Tab.Container>
      </Row>
      <AddTenantPackage
        show={showRazorpayModal}
        onClose={() => setShowRazorpayModal(false)}
        tenant={selectedData}
        fetchData={() => fetchData({ page, size, search })}
      />
    </>
  );
};

export default PendingTenant;
